import React from 'react'
import { PatientIdentityStatusEnum } from '../../_props'

type CheckMethod = (statuses: PatientIdentityStatusEnum[]) => boolean

const useCheckPatientStatus = (status: PatientIdentityStatusEnum | undefined) => {
    const checkStatus = React.useCallback<CheckMethod>(
        (statuses) => Boolean(status && statuses.includes(status)),
        [status],
    )

    return { checkStatus }
}

export default useCheckPatientStatus
